module.exports = __webpack_public_path__ + "static/img/button_icon.ee6d523.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/VXImage/button_icon.svg
// module id = LAn8
// module chunks = 0